
import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue";
import {namespace} from "vuex-class"; // @ is an alias to /src

const panierModule = namespace("panierModule");

@Component({
    components: {}
})
export default class Dashboard extends Vue {

    @panierModule.Mutation
    public setItemCat!: (itemCat: string) => void;

    public vue = new Vue({
        data: {
            pages: [
                {
                    "id": 1,
                    "name": "PARAMÈTRE UTILISATEUR"
                },
                {
                    "id": 2,
                    "name": "MES DOCUMENTS"
                },
                {
                    "id": 3,
                    "name": "HISTORIQUE DES COMMANDES"
                },
                {
                    "id": 4,
                    "name": "FACTURATION"
                },

            ],
        }
    });

    mounted(){
      this.setItemCat("Dashboard");
    }
}
